window.__UDL_CONFIG = window.__UDL_CONFIG || {};
window.$ULOG = window.$ULOG || {};
window.$ULOG.target =
  location.host == "gsm.zufangzi.com"
    ? "//dig.lianjia.com/c.gif"
    : "//test-dig.lianjia.com/c.gif";
window.$ULOG.autosend = false;
window.$ULOG.buffer = window.$ULOG.buffer || [];

const guid = function() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const getCookie = function(key) {
  return (key = RegExp("(^| )" + key + "=([^;]*)(;|$)").exec(document.cookie))
    ? key[2]
    : "";
};

const setCookie = function(key, value, options) {
  var expires;
  options.expires &&
    ((expires = new Date()),
    expires.setTime(expires.getTime() + options.expires));
  document.cookie =
    key +
    "=" +
    value +
    (options.domain ? "; domain=" + options.domain : "") +
    (options.path ? "; path=" + options.path : "") +
    (expires ? "; expires=" + expires.toGMTString() : "") +
    (options.secure ? "; secure" : "");
};

const ULOG = {
  pid: "guangsha_m_rent",
  uicode: "",
  uuid: "",
  ssid: guid(),
  init: function() {
    this.updateIds();
    const ulogScript = document.createElement("script");
    ulogScript.crossOrigin = "anonymous";
    ulogScript.src = "//s1.ljcdn.com/dig-log/static/1.1.0/lianjiaUlog.js";
    ulogScript.onload = () => {
      this.updateIds();
    };
    document.getElementsByTagName("head")[0].appendChild(ulogScript);
  },
  updateIds: function() {
    this.uuid = this.getUUID();
    window.__UDL_CONFIG = {
      pid: this.pid,
      uicode: this.uicode,
      uuid: this.uuid,
      ssid: this.ssid
    };
  },
  getUUID: function() {
    var guangshafe_uuid = getCookie("guangshafe_uuid");
    if (!guangshafe_uuid) {
      guangshafe_uuid = guid();
      setCookie("guangshafe_uuid", guangshafe_uuid, {
        path: "/",
        domain: this.domain,
        expires: 10 * 365 * 24 * 60 * 60 * 1000 // 有效期两年
      });
    }
    return guangshafe_uuid;
  },
  pageView: function(uicode, param = {}) {
    if (uicode) {
      this.uicode = uicode;
    }
    if (window.$ULOG.state == 1) {
      window.$ULOG.setConfig({
        pid: this.pid,
        uicode: this.uicode,
        uuid: this.uuid,
        ssid: this.ssid
      });
      window.$ULOG.send("1,3", param);
    } else {
      window.__UDL_CONFIG = {
        pid: this.pid,
        uicode: this.uicode,
        uuid: this.uuid,
        ssid: this.ssid
      };
      window.$ULOG.buffer.push(["1,3", param]);
    }
  },
  send: function(evtid, event, param = {}) {
    param = { ...param, event };
    if (window.$ULOG.state == 1) {
      window.$ULOG.send(evtid, param);
    } else {
      window.$ULOG.buffer.push([evtid, param]);
    }
  }
};

export default ULOG;
